<template>
  <div class="register">
    <section class="hero has-background-grey-lighter">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">
            Register
          </h1>
          <h2 class="subtitle">
            Create a new account
          </h2>
        </div>
      </div>
    </section>
    <div class="columns is-marginless is-centered">
      <form class="column is-half">
        <article v-if="errorMessage" class="message is-danger">
          <div class="message-header">
            <p>Error</p>
            <button type="button" class="delete" aria-label="delete" @click="errorMessage = null"></button>
          </div>
          <div class="message-body">
            {{errorMessage}}
          </div>
        </article>
        <div class="field">
          <p class="control has-icons-left">
            <input v-model="email" autocomplete="email" class="input" type="email" placeholder="Email">
            <span class="icon is-small is-left" :class="{'has-text-success': validInputs.includes('email')}">
              <i class="fas fa-envelope"></i>
            </span>
          </p>
        </div>
        <div class="field">
          <p class="control has-icons-left">
            <input v-model="name" autocomplete="name" name="name" class="input" type="text" placeholder="Name">
            <span class="icon is-small is-left" :class="{'has-text-success': validInputs.includes('name')}">
              <i class="fas fa-user"></i>
            </span>
          </p>
        </div>
        <div class="field">
          <p class="control has-icons-left">
            <input v-model="password" autocomplete="new-password" class="input" name="password" type="password" placeholder="Password">
            <span class="icon is-small is-left" :class="{'has-text-success': validInputs.includes('password')}">
              <i class="fas fa-lock"></i>
            </span>
          </p>
          <p class="help">Password must be at least 6 characters long</p>
        </div>
        <div class="field">
          <p class="control has-icons-left">
            <input v-model="password2" autocomplete="new-password" class="input" name="password-again" type="password" placeholder="Retype password">
            <span class="icon is-small is-left" :class="{'has-text-success': validInputs.includes('password2')}">
              <i class="fas fa-lock"></i>
            </span>
          </p>
        </div>
        <div class="field">
          <p class="control">
            <button :disabled="loading" type="button" @click="register()" class="button is-primary">
              Register
            </button>
            <span class="icon">
              <i v-if="loading" class="fas fa-circle-notch fa-spin"></i>
            </span>
          </p>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
export default {
  name: 'register',
  data: () => {
    return {
      email: '',
      name: '',
      password: '',
      password2: '',
      errorMessage: null,
      loading: false
    }
  },
  computed: {
    validInputs () {
      const validInputs = []
      if (this.isValidEmail(this.email)) validInputs.push('email')
      if (this.name.length > 2 && this.name.length < 30) validInputs.push('name')
      if (this.password.length > 5) validInputs.push('password')
      if (this.password === this.password2 && this.password2 !== '') validInputs.push('password2')
      return validInputs
    }
  },
  methods: {
    async register () {
      this.loading = true
      this.errorMessage = null
      if (this.validInputs.length !== 4) {
        this.errorMessage = 'One of the fields was not filled in with valid data'
        return
      }
      // Try to register user
      const result = await this.$store.dispatch('register', {
        email: this.email,
        password: this.password,
        name: this.name
      })
      this.loading = false
      if (result.error) {
        this.errorMessage = result.message
      } else if (result.success && result.token) {
        await this.$store.dispatch('setAuthToken', result.token)
        this.$router.push('/')
      }
    },
    isValidEmail (email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    }
  },
  async created () {
    if (await this.$store.dispatch('checkAuthToken')) return this.$router.push('/dashboard')
  }
}
</script>
